module.exports = __webpack_public_path__ + "static/img/14.dd52e40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhuoyue/14.jpg
// module id = hNFY
// module chunks = 2